export default __webpack_public_path__ + "static/media/TNJ 1.e64a6a4e.svg";